import type { Schemas } from "#shopware";

export const useShopwareCategories = () => {
	const route = useRoute();

	const { navigationElements } = useNavigation({ type: "main-navigation" });

	function flattenCategories(elements: Schemas["NavigationRouteResponse"] | null) {
		let flattened = [] as Schemas["NavigationRouteResponse"];

		elements?.forEach((element) => {
			flattened.push(element);
			if (element.children && element.children.length > 0) {
				flattened = flattened.concat(flattenCategories(element.children));
			}
		});

		return flattened;
	}

	// get flattend categories
	const categories = computed(() => flattenCategories(navigationElements.value));

	// get current navigation ignoring level
	const currentCategory = computed<Schemas["Category"] | undefined>(
		() =>
			categories.value?.find(
				(category) =>
					!!category.seoUrls &&
					Array.isArray(category.seoUrls) &&
					category.seoUrls[0].seoPathInfo === route.path.slice(1)
			) as Schemas["Category"] | undefined
	);

	// get level 3 navigation: categories
	const baseCategories = computed(() => categories.value.filter((category) => category.level === 3));

	// get level 4 navigation: sub-categories
	const subCategories = computed(() =>
		categories.value?.filter(
			(category) =>
				category.level === 4 &&
				(category.parentId === currentCategory.value?.id ||
					category.parentId === currentCategory.value?.parentId)
		)
	);

	return {
		baseCategories,
		currentCategory,
		subCategories
	};
};
